<aw-section
  testIdAffix="appearance-standard-controls"
  [isCollapsible]="true"
  [forceCollapse]="forceCollapse()"
  [withoutContentPadding]="true">
  <aw-section-header>
    <div class="grid w-full grid-cols-1 lg:grid-cols-[1fr_minmax(0,6rem)_7fr]">
      <span
        class="text-standard-text-primary text-2xl font-semibold lg:col-span-4">
        {{ cmsTextProvider.appearanceText.controls }}
      </span>
    </div>
  </aw-section-header>

  <div
    class="grid grid-cols-1 gap-6 pt-7 xl:grid-cols-[minmax(12rem,1fr)_minmax(0,4fr)]">
    <h3 class="text-standard-text-primary ml-8 text-xl font-semibold">
      {{ cmsTextProvider.appearanceText.controlsColours }}
    </h3>

    <div class="min-w-0">
      <p class="text-standard-text-secondary text-m mb-2 leading-5">
        {{ cmsTextProvider.appearanceText.controlsColoursHint }}
      </p>

      <div class="grid grid-cols-1 gap-3 2xl:grid-cols-2">
        <ng-container
          *ngTemplateOutlet="previewCard; context: { dark: false }" />
        <ng-container
          *ngTemplateOutlet="previewCard; context: { dark: true }" />
      </div>
    </div>
  </div>
</aw-section>

<ng-template #previewCard let-dark="dark">
  <article
    class="rounded-md border"
    [ngClass]="
      dark
        ? 'border-neutral-700 bg-[#111111] text-neutral-100'
        : 'border-standard-outline-light text-standard-text-primary bg-white'
    ">
    <div class="flex justify-end px-3 pt-3">
      <span
        class="inline-flex h-8 items-center justify-center gap-1.5 rounded-full border px-2.5 py-0 text-sm leading-none"
        [ngClass]="
          dark
            ? 'border-neutral-700 bg-neutral-800 text-neutral-300'
            : 'border-standard-outline-light bg-white'
        ">
        <span
          aria-hidden="true"
          class="material-symbols-rounded icon-filled inline-flex size-5 shrink-0 items-center justify-center !text-lg leading-none">
          {{ dark ? 'dark_mode' : 'light_mode' }}
        </span>
        <span class="inline-flex h-5 items-center leading-none">
          {{
            dark
              ? cmsTextProvider.appearanceText.controlsDarkMode
              : cmsTextProvider.appearanceText.controlsLightMode
          }}
        </span>
      </span>
    </div>

    <div class="grid grid-cols-[minmax(0,1fr)_minmax(9rem,1fr)] gap-5 p-3">
      <div class="flex min-w-0 flex-col gap-2">
        <button
          type="button"
          tabindex="-1"
          class="flex h-10 items-center justify-center gap-3 rounded-lg border font-semibold"
          [style.backgroundColor]="fillColor(dark)"
          [style.borderColor]="borderColor(dark)"
          [style.color]="contrastColor(dark)">
          <span class="material-symbols-rounded">add</span>
          {{ cmsTextProvider.appearanceText.controlsAction }}
        </button>

        <button
          type="button"
          tabindex="-1"
          class="flex h-10 items-center justify-center gap-3 rounded-lg border bg-transparent font-semibold"
          [style.borderColor]="outlineColor(dark)"
          [style.color]="outlineColor(dark)">
          <span class="material-symbols-rounded">add</span>
          {{ cmsTextProvider.appearanceText.controlsSecondaryAction }}
        </button>

        <button
          type="button"
          tabindex="-1"
          class="flex h-9 items-center justify-center gap-3 bg-transparent font-semibold"
          [style.color]="outlineColor(dark)">
          <span class="material-symbols-rounded">add</span>
          {{ cmsTextProvider.appearanceText.controlsTertiaryAction }}
        </button>

        <div
          class="relative flex h-11 items-center rounded-lg border px-3 pt-2"
          [ngClass]="dark ? 'border-neutral-700' : 'border-neutral-300'">
          <span
            class="absolute -top-2 left-3 px-1 text-sm"
            [ngClass]="dark ? 'bg-[#111111]' : 'bg-white'">
            {{ cmsTextProvider.appearanceText.controlsLabel }}
          </span>
          <span class="flex-1 text-base">{{
            cmsTextProvider.appearanceText.controlsInput
          }}</span>
          <span class="material-symbols-rounded text-lg">close</span>
        </div>

        <div
          class="relative flex h-11 items-center rounded-lg border-2 px-3 pt-2"
          [style.borderColor]="outlineColor(dark)">
          <span
            class="absolute -top-2 left-3 px-1 text-sm"
            [ngClass]="dark ? 'bg-[#111111]' : 'bg-white'"
            [style.color]="outlineColor(dark)">
            {{ cmsTextProvider.appearanceText.controlsLabel }}
          </span>
          <span class="flex-1 text-base">{{
            cmsTextProvider.appearanceText.controlsInput
          }}</span>
          <span class="material-symbols-rounded text-lg">close</span>
        </div>
      </div>

      <div
        class="grid grid-cols-[1fr_auto_auto] items-center gap-x-4 gap-y-5 text-base">
        <span>{{ cmsTextProvider.appearanceText.controlsCheckbox }}</span>
        <span
          class="flex size-5 items-center justify-center justify-self-center rounded"
          [style.backgroundColor]="fillColor(dark)"
          [style.color]="contrastColor(dark)">
          <span class="material-symbols-rounded text-base">check</span>
        </span>
        <span
          class="size-5 justify-self-center rounded border border-neutral-400"></span>

        <span>{{ cmsTextProvider.appearanceText.controlsRadio }}</span>
        <span
          class="flex size-5 items-center justify-center justify-self-center">
          <svg
            aria-hidden="true"
            class="size-5"
            viewBox="0 0 20 20"
            style="border-radius: 8px"
            [style.background]="fillColor(dark)"
            [style.color]="contrastColor(dark)">
            <circle
              cx="10"
              cy="10"
              r="8"
              fill="none"
              stroke="currentColor"
              stroke-width="2" />
            <circle cx="10" cy="10" r="4" fill="currentColor" />
          </svg>
        </span>
        <span
          class="flex size-5 items-center justify-center justify-self-center">
          <span
            class="size-[18px] rounded-full border-2"
            [ngClass]="
              dark ? 'border-neutral-400' : 'border-neutral-500'
            "></span>
        </span>

        <span>{{ cmsTextProvider.appearanceText.controlsSwitch }}</span>
        <span
          class="flex h-7 w-11 items-center justify-end justify-self-center rounded-full p-1"
          [style.backgroundColor]="fillColor(dark)">
          <span
            class="size-5 rounded-full"
            [style.backgroundColor]="contrastColor(dark)"></span>
        </span>
        <span
          class="flex h-7 w-11 items-center justify-self-center rounded-full border border-neutral-500 p-1">
          <span class="size-4 rounded-full bg-neutral-500"></span>
        </span>

        <div
          class="col-span-3 grid h-10 grid-cols-2 overflow-hidden rounded-lg border"
          [ngClass]="dark ? 'border-neutral-700' : 'border-neutral-300'">
          <span
            class="flex items-center justify-center gap-2 font-semibold"
            [style.backgroundColor]="fillColor(dark)"
            [style.color]="contrastColor(dark)">
            <span class="material-symbols-rounded text-base">check</span>
            {{ cmsTextProvider.appearanceText.controlsLabel }}
          </span>
          <span class="flex items-center justify-center">
            {{ cmsTextProvider.appearanceText.controlsLabel }}
          </span>
        </div>
      </div>
    </div>

    <div
      class="mx-3 border-t"
      [ngClass]="dark ? 'border-neutral-800' : 'border-neutral-200'"></div>

    <div class="flex flex-col gap-3 p-3">
      @for (color of colors; track color.key) {
        <div>
          <div class="relative flex items-center gap-2 text-base">
            <aw-color-picker-list 
              [color]="swatchColor(color.key, dark)"
              (colorChanged)="selectColor(color.key, dark, $event)"></aw-color-picker-list>
            <span>{{ color.label }}</span>
          </div>

          @if (color.description) {
            <p
              class="mt-1 pl-8 text-sm leading-5"
              [ngClass]="dark ? 'text-neutral-400' : 'text-neutral-500'">
              {{ color.description }}
            </p>
          }
        </div>
      }
    </div>
  </article>
</ng-template>
